<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';
import { useVoiceCallStatus } from 'dashboard/composables/useVoiceCallStatus';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data);

const status = computed(() => data.value?.status);
const direction = computed(() => data.value?.call_direction);
const duration = computed(() => data.value?.duration || 0);
const recordingUrl = computed(() => data.value?.recording_url || '');

const { labelKey, subtextKey, bubbleIconBg, bubbleIconName } =
  useVoiceCallStatus(status, direction);

const containerRingClass = computed(() => {
  return status.value === 'ringing' ? 'ring-1 ring-emerald-300' : '';
});

const formattedDuration = computed(() => {
  if (!duration.value || duration.value <= 0) return '';
  const mins = Math.floor(duration.value / 60);
  const secs = duration.value % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
});
</script>

<template>
  <BaseBubble class="p-0 border-none" hide-meta>
    <div
      class="flex overflow-hidden flex-col w-full max-w-xs bg-white rounded-lg border border-slate-100 text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      :class="containerRingClass"
    >
      <div class="flex gap-3 items-center p-3 w-full">
        <div
          class="flex justify-center items-center rounded-full size-10 shrink-0"
          :class="bubbleIconBg"
        >
          <span class="text-xl" :class="bubbleIconName" />
        </div>

        <div class="flex overflow-hidden flex-col flex-grow">
          <span class="text-base font-medium truncate">{{ $t(labelKey) }}</span>
          <div class="flex items-center gap-2">
            <span class="text-xs text-slate-500">{{ $t(subtextKey) }}</span>
            <span
              v-if="formattedDuration"
              class="text-xs font-medium text-slate-600 dark:text-slate-400"
            >
              {{ formattedDuration }}
            </span>
          </div>
        </div>
      </div>
      <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
      <audio
        v-if="recordingUrl"
        controls
        class="w-full px-3 pb-3"
        :src="recordingUrl"
      />
    </div>
  </BaseBubble>
</template>
